import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import {
  Fade,
  ModalWrapper,
  ButtonsWrapper,
  PhoneRow,
  CloseText,
} from './call.styled';
import { Text, Button, SVG, message } from '../../components-v4';
import { ReactComponent as PhoneIcon } from '../../assets/phone.svg';
import { ReactComponent as CopyIcon } from '../../assets/clone.svg';
import { useAppDispatch } from '../../../../hooks';
import { setShowCallCard } from '../../request-single-page-slice';
import { getPublicRequestData } from '../../selectors';
import { formatStrNumberWithCode } from '../../utils';

export const Call: FC = memo(() => {
  const dispatch = useAppDispatch();
  const requestData = useSelector(getPublicRequestData);

  const handleClose = () => {
    dispatch(setShowCallCard(false));
  };

  const handleCall = (phoneNumber: string) => {
    const link = document.createElement('a');
    link.href = `tel:${phoneNumber}`;
    link.click();
  };

  const handleCopy = (phoneNumber: string) => {
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => {
        message({
          type: 'success',
          text: 'Номер скопирован',
        });
      })
      .catch(() => {
        message({
          type: 'error',
          text: 'Упс... Что-то пошло не так, повторите попытку',
        });
      });
  };

  return (
    <>
      <Fade />
      <ModalWrapper>
        <CloseText onClick={handleClose}>Закрыть</CloseText>
        <Text
          variant="heading-3"
          color="gray.800"
          style={{ width: '100%', textAlign: 'center' }}
        >
          Звонок диспетчеру
        </Text>
        <Text
          variant="body-16"
          color="gray.500"
          style={{ textAlign: 'center', padding: '16px 0' }}
        >
          Вам потребуется совершить звонок по мобильной связи. Пожалуйста,
          подготовьте номер заявки и кратко опишите проблему.
        </Text>
        <ButtonsWrapper>
          {requestData.dispatcher_phones.map((phoneNumber) => (
            <PhoneRow key={phoneNumber}>
              <Button
                mode="neutral"
                variant="main"
                size="l"
                iconButton={<SVG src={CopyIcon} />}
                onClick={() => handleCopy(phoneNumber)}
              />
              <Button
                mode="accent"
                variant="main"
                size="l"
                leftIcon={
                  <SVG
                    src={PhoneIcon}
                    props={{ color: '#ffffff' }}
                    complex={true}
                  />
                }
                style={{ flex: 1 }}
                onClick={() => handleCall(phoneNumber)}
              >
                {formatStrNumberWithCode(phoneNumber)}
              </Button>
            </PhoneRow>
          ))}
        </ButtonsWrapper>
      </ModalWrapper>
    </>
  );
});
